import React from 'react';
import { Navigate, Outlet, Link } from 'react-router-dom';

const PrivateRoute = () => {
    const token = localStorage.getItem('token');

    // If token is present, allow access to the route (Outlet)
    if (token) {
        return <Outlet />;
    }

    // If no token, show "Session Expired" message
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            backgroundColor: '#f8fafc',
            textAlign: 'center',
            padding: '20px'
        }}>
            <div style={{
                backgroundColor: 'white',
                padding: '40px',
                borderRadius: '16px',
                boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
                maxWidth: '400px',
                width: '100%'
            }}>
                <div style={{ fontSize: '48px', marginBottom: '20px' }}>⚠️</div>
                <h2 style={{
                    fontSize: '1.5rem',
                    color: 'var(--proto-white)',
                    marginBottom: '10px',
                    fontWeight: 700
                }}>
                    User session is expired
                </h2>
                <p style={{ color: 'var(--text-muted)', marginBottom: '24px' }}>
                    Please login again to continue accessing the platform.
                </p>
                <Link
                    to="/login"
                    style={{
                        display: 'inline-block',
                        backgroundColor: 'var(--proto-white)',
                        color: 'white',
                        padding: '12px 24px',
                        borderRadius: '8px',
                        textDecoration: 'none',
                        fontWeight: 600,
                        transition: 'background-color 0.2s'
                    }}
                >
                    Click here to Login
                </Link>
            </div>
        </div>
    );
};

export default PrivateRoute;


